import React from "react";
import { formatHours, formatStartWindow } from "@/lib/utils";
import { parseISO, format } from "date-fns";
import { MOVE_KINDS_SHORT, SERVICE_TYPES } from "@/constants";
import { Move } from "@/types";
import {
  UserIcon,
  TruckIcon,
  ClockIcon,
  CircleDollarSignIcon,
  BoxIcon,
  HourglassIcon,
  CalendarIcon,
} from "lucide-react";

interface SummaryProps {
  move: Move;
}

const Summary: React.FC<SummaryProps> = ({ move }) => {
  return (
    <div className="flex flex-row flex-wrap justify-start items-start gap-4">
      <div className="flex flex-col justify-start items-start gap-0.5">
        <div className="flex flex-row items-center gap-1">
          <CalendarIcon className="w-3 h-3" />
          <p className="text-xs text-stone-700">Date</p>
        </div>
        <div className="flex justify-center items-center gap-1">
          <p className="text-sm font-semibold">
            {move.service_date
              ? format(parseISO(move.service_date), "MM/dd/yyyy")
              : "-"}
          </p>
          {/* {move.service_date && isFuture(parseISO(move.service_date)) && (
            <p className="text-sm">
              {differenceInDays(parseISO(move.service_date), new Date())} days
              from now
            </p>
          )} */}
        </div>
      </div>
      <div className="flex flex-col justify-start items-start gap-0.5">
        <div className="flex flex-row items-center gap-1">
          <ClockIcon className="w-3 h-3" />
          <p className="text-xs text-stone-700">Arrival Window</p>
        </div>
        <div className="flex justify-center items-center gap-1">
          <ClockIcon className="w-3 h-3" />
          <p className="text-sm font-semibold">
            {formatStartWindow(
              move.start_window_begin_hour,
              move.start_window_begin_minute,
              move.start_window_begin_meridiem
            )}{" "}
            to{" "}
            {formatStartWindow(
              move.start_window_end_hour,
              move.start_window_end_minute,
              move.start_window_end_meridiem
            )}
          </p>
        </div>
      </div>
      <div className="hidden flex flex-col justify-start items-start gap-0.5">
        <div className="flex flex-row items-center gap-1">
          <HourglassIcon className="w-3 h-3" />
          <p className="text-xs text-stone-700">Est. Hours</p>
        </div>
        <div className="flex justify-center items-center gap-1">
          <p className="text-sm font-semibold">
            {formatHours(move.hours_taken || move.hours_estimate)}
          </p>
        </div>
      </div>
      <div className="flex flex-col justify-start items-start gap-0.5">
        <div className="flex flex-row items-center gap-1">
          <BoxIcon className="w-3 h-3" />
          <p className="text-xs text-stone-700">Service</p>
        </div>
        <div className="flex flex-row items-center gap-1">
          <p className="text-sm font-semibold">
            {move.num_of_rooms && `${move.num_of_rooms}BR`}{" "}
            {MOVE_KINDS_SHORT[move.kind as keyof typeof MOVE_KINDS_SHORT]}{" "}
            {SERVICE_TYPES[move.service_type as keyof typeof SERVICE_TYPES]}
          </p>
        </div>
      </div>
      <div className="flex flex-row items-start gap-4">
        <div className="flex flex-col justify-start items-start gap-0.5">
          <div className="flex flex-row items-center gap-1">
            <UserIcon className="w-3 h-3" />
            <p className="text-xs text-stone-700">Movers</p>
          </div>
          <div className="flex justify-center items-center text-base font-semibold gap-1">
            <UserIcon className="w-4 h-4" />
            {move.num_of_movers}
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-0.5">
          <div className="flex flex-row items-center gap-1">
            <TruckIcon className="w-3 h-3" />
            <p className="text-xs text-stone-700">Trucks</p>
          </div>
          <div className="flex justify-center items-center text-base font-semibold gap-1">
            <TruckIcon className="w-4 h-4" />
            {move.num_of_trucks}
          </div>
        </div>
      </div>
      {move.invoice?.total && (
        <div>
          <div className="flex justify-center items-center text-base font-semibold gap-1">
            <CircleDollarSignIcon className="w-4 h-4" />
            {move.invoice?.total?.toLocaleString()}
            <p className="text-sm font-normal">total</p>
          </div>
        </div>
      )}
    </div>
  );
  // return (
  //   <div className="flex flex-wrap flex-row justify-start items-start gap-8 lg:gap-6">
  //     <div>
  //       <div>
  //         <h3 className="text-base font-semibold">
  //           {SERVICE_TYPES[move.service_type as keyof typeof SERVICE_TYPES]}
  //         </h3>
  //         <p className="text-sm">
  //           {move.num_of_rooms && `${move.num_of_rooms}BR`}{" "}
  //           {MOVE_KINDS_SHORT[move.kind as keyof typeof MOVE_KINDS_SHORT]}
  //         </p>
  //       </div>
  //     </div>
  //     <div>
  //       <p className="text-base font-semibold">
  //         {move.service_date
  //           ? formatDateWithOrdinal(parseISO(move.service_date))
  //           : "-"}
  //       </p>
  //       {move.service_date && isFuture(parseISO(move.service_date)) && (
  //         <p className="text-sm">
  //           {differenceInDays(parseISO(move.service_date), new Date())} days
  //           from now
  //         </p>
  //       )}
  //     </div>
  //     {move.status === "booked" && (
  //       <div>
  //         <p className="text-base font-semibold">
  //           {formatStartWindow(
  //             move.start_window_begin_hour,
  //             move.start_window_begin_minute,
  //             move.start_window_begin_meridiem
  //           )}
  //         </p>
  //         <p className="text-sm">start time</p>
  //       </div>
  //     )}
  //     <div>
  //       <div className="flex justify-center items-center text-base font-semibold gap-1">
  //         <UserIcon className="w-4 h-4" />
  //         {move.num_of_movers}
  //       </div>
  //       <p className="text-sm">movers</p>
  //     </div>
  //     <div>
  //       <div className="flex justify-center items-center text-base font-semibold gap-1">
  //         <TruckIcon className="w-4 h-4" />
  //         {move.num_of_trucks}
  //       </div>
  //       <p className="text-sm">trucks</p>
  //     </div>
  //     <div>
  //       <div className="flex justify-center items-center text-base font-semibold gap-1">
  //         <ClockIcon className="w-4 h-4" />
  //         {formatHours(move.hours_taken || move.hours_estimate)}
  //       </div>
  //       <p className="text-sm">{move.hours_taken ? "taken" : "estimated"}</p>
  //     </div>
  //     <div>
  //       <div className="flex justify-center items-center text-base font-semibold">
  //         <DollarSignIcon className="w-4 h-4" />
  //         {`${move.invoice?.total?.toLocaleString() || "n/a"}`}
  //       </div>
  //       <p className="text-sm">total</p>
  //     </div>
  //   </div>
  // );
};

export default Summary;
